module.exports = __webpack_public_path__ + "media/BNP_Samodzielniak_Bankoslowka_WYTWORNIA_PAPIEROW.550e59f9.mp3";